import { CommonModule } from '@angular/common';
import { Component, Input, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { AppService } from 'src/app/services/app/app.service';
import { LanguagesService } from 'src/app/services/languages/languages.service';
import { CreateAppComponent } from 'src/app/components/pages/myapps/create-app/create-app.component';
import { ThemeService } from 'src/app/services/theme/theme.service';


@Component({
  selector: 'app-create-update-modal',
  imports: [CommonModule, FormsModule, CreateAppComponent],
  templateUrl: './create-update-modal.component.html',
  styleUrl: './create-update-modal.component.css'
})
export class CreateUpdateModalComponent {

    @Input() payitem: any; // sub_domain და სხვა მონაცემები


    @ViewChild('createApp') createAppComponent!: CreateAppComponent;

    createStart = false

    selectedLanguage: any
    loadPay = false
    loadPayApp = 0

    selectedPackage: string = '';

    infoPackageModalRef: NgbModalRef | null = null;

    selectedMonths: number = 1;
    basePrice: number = 20; // 1 თვის ფასი
    totalPrice: number = this.basePrice;
    monthsOptions: number[] = [1, 3, 6, 12]; // არჩევის ვარიანტები

    business_type = 'restaurant'

    constructor(
      private modalService: NgbModal,
      private languageService: LanguagesService,
      private AppService: AppService,
      private ToastrService: ToastrService,
      private ThemeService: ThemeService
    ){
      this.languageService.selectedLanguage$.subscribe((language) => {
        this.selectedLanguage = language;
      });
    
    }


    triggerCreate() {
      if (this.createAppComponent) {
        console.log(1)
        this.createAppComponent.create(this.selectedPackage);
      }else {
        console.log(0)

      }
    }

    calculatePrice() {
      if(this.payitem.package === 'pro') {
        this.basePrice = 40
      }else{
        this.basePrice = 20
      }
      this.totalPrice = this.selectedMonths * this.basePrice;
    }


  openInfoModal(content: any, packageType: string) {
        this.selectedPackage = packageType;
        this.infoPackageModalRef = this.modalService.open(content, { });
  }

  closeInfoModal() {
        if (this.infoPackageModalRef) {  // შეამოწმე, რომ modal არსებობს
            this.infoPackageModalRef.close();
            this.infoPackageModalRef = null; // გაასუფთავე რეფერენსი
        }
  }


  changePackage(pack: string){
    this.payitem.package = pack
    this.selectedPackage = pack
    if(pack == 'pro'){
      this.basePrice = 40
    }
    if(pack == 'minimal'){
      this.basePrice = 20
    }
    this.calculatePrice()
    this.closeInfoModal()
  }
isMinimalCollapsed = true;
isProCollapsed = true;

toggleCollapse(type: 'minimal' | 'pro') {
  if (type === 'minimal') {
    this.isMinimalCollapsed = !this.isMinimalCollapsed;
  } else {
    this.isProCollapsed = !this.isProCollapsed;
  }
}
  pey(data: any){

    this.loadPayApp = data.id
    this.loadPay = true;


    data.selectedMonths = this.selectedMonths;
    data.package = this.selectedPackage;
    data.currency = 'GEL';
    data.language = this.selectedLanguage.code === 'ka_GE' ? 'ka' : 'en';
    data.total_amount = this.selectedPackage === 'minimal' ? 0 : 0;

    console.log(data)
    data.theme = this.ThemeService.getThemes()

    if(this.payitem?.create){
      data.create = this.payitem?.create;
      this.createStart = true
      this.triggerCreate()
    }else {
      this.createStart = false
      this.AppService.pey(data).subscribe(
        (res: any) => {
          this.loadPay = false;
          console.log('res: ', res)
          if (res && res.payment_url) {
            const paymentUrl = res.payment_url + '&theme=' + this.ThemeService.getThemes();
            // const paymentUrl = res.payment_url;
            window.location.href = paymentUrl; // გადამისამართება იმავე ფანჯარაში
          } else {
            console.error('Payment URL not found in response:', res);
          }
        },
        (err) => {
          this.loadPay = false;
          console.error('Payment request failed:', err);
        }
      );

    }

  }


}
